import { formatGymPrice } from '../../../utils/gymMoney';

export const specializationOptions = [
  'Weight Training',
  'Yoga & Pilates',
  'CrossFit',
  'Cardio',
  'Nutrition',
  'Boxing',
];

export function formatCurrency(amount) {
  return formatGymPrice(amount);
}
